<template>
  <div class="def-slide-modal" @wheel.prevent>
    <DefSlideRight>
      <div v-if="active" class="def-slide-modal__block">
        <span class="def-slide-modal__close" @click="$emit('close')">
          <svg class="def-slide-modal__icon"><use xlink:href="#svg-close"></use></svg>
        </span>
        <h2 v-if="$slots.title" class="def-slide-modal__title">
          <slot name="title" />
        </h2>
        <DefScrollbar class="def-slide-modal__scroll">
          <slot />
        </DefScrollbar>
        <slot v-if="$slots.footer" name="footer" />
      </div>
    </DefSlideRight>
    <DefDarkenBackground v-if="active" @close="$emit('close')" />
  </div>
</template>

<script>
import DefSlideRight from '@components/Def/DefAnimations/DefSlideRight.vue';
import DefDarkenBackground from '@components/Def/DefDarkenBackground/DefDarkenBackground.vue';
import DefScrollbar from '@components/Def/DefScrollbar/DefScrollbar.vue';

export default {
  name: 'DefSlideModal',
  components: { DefScrollbar, DefDarkenBackground, DefSlideRight },
  props: ['active'],
  mounted() {
    // console.log(this.$slots.title);
  },
};
</script>

<style lang="scss" scoped>
.def-slide-modal {
  &__block {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    z-index: 1001;
    background-color: #fff;
    padding: 40px 6px 0 16px;
    @include point-md {
      width: 640px;
      padding: 36px 14px 0 24px;
    }
    @include point-lg {
      width: 840px;
      padding: 68px 40px 0 60px;
    }
  }
  &__close {
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
    @include point-md {
      top: 16px;
      right: 16px;
    }
    @include point-lg {
      top: 64px;
      right: 60px;
    }
    &:hover {
      svg {
        fill: var(--color-red);
      }
    }
  }
  &__icon {
    display: block;
    width: 32px;
    height: 32px;
    transition: 0.2s linear fill;
  }
  &__title {
    font-weight: 600;
    font-size: rem(18);
    letter-spacing: 0.04em;
    text-transform: uppercase;
    margin-bottom: 16px;
    @include point-md {
      font-size: rem(24);
      margin-bottom: 32px;
    }
  }
  &__scroll {
    overflow-x: auto;
    position: relative;
    padding-right: 20px;
    flex-grow: 1;
  }
}
</style>
